// src/routes/PrivateRoute.js
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isTokenValid, logout } from "../utils/auth";
import { mapToCanonicalRole } from "../utils/roleMap";

/**
 * PrivateRoute
 * - Exige token válido (via isTokenValid)
 * - Normaliza role/tipo para os canônicos do backend
 * - Autoriza somente se o cargo canônico estiver em rolesAllowed
 */
export default function PrivateRoute({ rolesAllowed = [] }) {
  const location = useLocation();
  const token = localStorage.getItem("token");

  // 1) Token obrigatório e válido
  // Aqui passa o state.from para o Login saber para onde voltar
  if (!token || !isTokenValid()) {
    console.warn("🔒 Sessão inválida ou expirada. Redirecionando para login...");
    logout();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2) Papel do usuário → canônico
  const rawRole = localStorage.getItem("role") || "";
  const rawTipo = localStorage.getItem("tipo") || "";
  // Usa a função centralizada para garantir consistência
  const canonicalRole = mapToCanonicalRole(rawRole || rawTipo || "servidor");

  // 3) Autorização por grupo informado na rota
  const allowed =
    !rolesAllowed || rolesAllowed.length === 0 || rolesAllowed.includes(canonicalRole);

  if (!allowed) {
    console.warn(
      `🚫 Acesso negado: cargo "${canonicalRole}" não tem permissão para acessar ${location.pathname}.`
    );
    
    // <<< CORREÇÃO PARA EVITAR LOOP INFINITO >>>
    // Define para onde mandar o usuário caso ele tente acessar algo proibido.
    // Não podemos mandar Executivo/Painel para Dashboard, pois eles não têm acesso.
    
    let fallbackRoute = "/dashboard"; // Padrão para vereadores e admin

    if (canonicalRole === "executivo") fallbackRoute = "/executivo";
    else if (canonicalRole === "painel") fallbackRoute = "/painelsessao";
    else if (canonicalRole === "obspainel") fallbackRoute = "/obs";

    // Se ele já estiver na rota de fallback e mesmo assim for barrado (erro de config),
    // mandamos para login para evitar loop total.
    if (location.pathname === fallbackRoute) {
        return <Navigate to="/login" replace />;
    }

    return <Navigate to={fallbackRoute} replace />;
  }

  return <Outlet />;
}